import React, { useState } from "react";
import client from "@culturehq/client";
import { Pagination } from "@culturehq/components";

import { useFetch, useFieldsLabels } from "app/hooks";
import { DepartmentLink, LocationLink } from "app/links";
import { Trans } from "app/utils";

import { TimeDiff } from "components/common/Time";
import UserName from "components/common/UserName";

import ProfileTable from "./ProfileTable";

const UserConnection = ({ connection }) => {
  const user = connection.sender;

  return (
    <tr>
      <td>
        <UserName user={user} />
      </td>
      <td>
        {user.departments.map((department, index) => (
          <span key={department.id}>
            <DepartmentLink department={department} />
            {index !== user.departments.length - 1 && ", "}
          </span>
        ))}
      </td>
      <td>
        {user.location && <LocationLink location={user.location} />}
      </td>
      <td>
        <TimeDiff time={connection.createdAt} />
      </td>
    </tr>
  );
};

const UserFollowers = ({ user }) => {
  const labels = useFieldsLabels();

  const [page, setPage] = useState(1);

  const { fetching, json } = useFetch(
    () => {
      if (!user.id) {
        return Promise.resolve({});
      }
      return client.listUserReceivedConnections({ page, userId: user.id });
    },
    [page, user]
  );

  const { connections = [], pagination = {} } = json;

  return (
    <>
      <ProfileTable loading={fetching}>
        <thead>
          <tr>
            <th>
              <Trans>Name</Trans>
            </th>
            <th>
              <Trans>{labels.departments.plural}</Trans>
            </th>
            <th>
              <Trans>Location</Trans>
            </th>
            <th>
              <Trans>Since</Trans>
            </th>
          </tr>
        </thead>
        <tbody>
          {!fetching && connections.length < 1 && (
            <tr>
              <td colSpan={4}>
                <Trans>No connections added</Trans>
              </td>
            </tr>
          )}
          {connections.map(connection => (
            <UserConnection key={connection.id} connection={connection} />
          ))}
        </tbody>
      </ProfileTable>
      <Pagination {...pagination} onClick={setPage} />
    </>
  );
};

export default UserFollowers;
